import React, { useState, useEffect, useRef } from 'react'
import 'katex/dist/katex.min.css'
import { PieChart, Pie, ResponsiveContainer, Cell, Tooltip } from 'recharts'
import { SlideQuestion } from '../UIUtilsFiles/SlideQuestion'

function FractionComponent(props) {
  const {
    fractionData,
    isPractice,
    completed,
    isActive,
    onValueChange,
    onAttemptChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    isEmbeded,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    sequenceMessage,
    handleSucAndFailFeedback,
    controlDimension = {
      heightPx: 50,
      widthPx: 100
    }
  } = props
  const {
    ControlID,
    Answers,
    LayoutType = 'Spiral',
    Score,
    AnswerColorFill,
    AnswerFillColor,
    SelectionColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    Priority,
    SequenceHint,
    BorderColor,
    FontStyle,
    Italic,
    Bold
  } = fractionData

  const sliceCount = Answers.split('/')[1]
    ? parseInt(Answers.split('/')[1])
    : parseInt(Answers)
  const answerSlice = Answers.split('/')[0]
    ? parseInt(Answers.split('/')[0])
    : parseInt(Answers)
  const [selectedFraction, setSelectedFraction] = useState(-1)
  const [isCorrect, setIsCorrect] = useState(false)
  const [spiralData, setSpiralData] = useState([])

  useEffect(() => {
    if (defaultValue && defaultValue.CtlValue) {
      let defaultValueSelected = defaultValue.CtlValue
      if (typeof defaultValueSelected === 'string') {
        const prevSelectedFraction = Answers.split('/')[1]
          ? parseInt(defaultValueSelected.split('/')[0])
          : parseInt(defaultValueSelected)
        setSelectedFraction(prevSelectedFraction - 1)
      } else {
        setSelectedFraction(-1)
      }
    } else {
    }
  }, [defaultValue])

  useEffect(() => {
    if (selectedFraction >= 0) {
      const selectedAnswer = Answers.split('/')[1]
        ? (selectedFraction + 1).toString() + '/' + sliceCount.toString()
        : (selectedFraction + 1).toString()
      if (selectedAnswer === Answers) {
        setIsCorrect(true)
      } else {
        setIsCorrect(false)
      }
    }
  }, [selectedFraction])

  //Split answer for spiral
  useEffect(() => {
    let data = []
    Array(sliceCount)
      .fill(0)
      .map((_, index) => {
        data.push({ name: index + 1 + '/' + sliceCount, values: 1 })
      })
    setSpiralData(data)
  }, [])

  useEffect(() => {
    if (followTheFlow && currentPriority) {
      if (currentPriority === Priority) {
        sequenceMessage(SequenceHint)
      }
    }
  }, [currentPriority])

  useEffect(() => {
    if (timerEnd) {
      const selectedAnswer = Answers.split('/')[1]
        ? (selectedFraction + 1).toString() + '/' + sliceCount.toString()
        : (selectedFraction + 1).toString()
      validateCorrectAnswer(true, selectedAnswer)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function explanationValidation() {
    let isCorrect = validateAnswer()
    if (isCorrect) {
      onExplanationVisible(true, CorrectAnswerExplanation)
    } else {
      onExplanationVisible(false, IncorrectAnswerExplanation)
    }
  }

  function fractionClick(selectedValue) {
    if (selectedValue >= 0) {
      const selectedAnswer = Answers.split('/')[1]
        ? (selectedValue + 1).toString() + '/' + sliceCount.toString()
        : (selectedValue + 1).toString()
      validateCorrectAnswer(false, selectedAnswer)
    }
  }

  function validateAnswer() {
    let isCorrect = false
    const selectedAnswer = Answers.split('/')[1]
      ? (selectedFraction + 1).toString() + '/' + sliceCount.toString()
      : (selectedFraction + 1).toString()
    if (selectedAnswer === Answers) {
      isCorrect = true
    } else {
      isCorrect = false
    }
    return isCorrect
  }

  function validateCorrectAnswer(timerValue, optionValue) {
    onAttemptChange(1)
    //Change priority value
    if (onPriorityChange && followTheFlow) {
      if (isPractice) {
        if (optionValue === Answers) {
          onPriorityChange(Priority)
        }
      } else {
        onPriorityChange(Priority)
      }
    }
    if (optionValue === Answers) {
      if (isPractice) {
        handleSuccessChange(true)
        if (isEmbeded) {
          handleSucAndFailFeedback(true)
        }
      }
      onValueChange(
        ControlID,
        optionValue,
        Score,
        Score,
        selectedFraction,
        timerValue
      )
    } else {
      if (isPractice) {
        handleSuccessChange(false)
        if (isEmbeded) {
          handleSucAndFailFeedback(false)
        }
      }
      onValueChange(
        ControlID,
        optionValue,
        0,
        Score,
        selectedFraction,
        timerValue
      )
    }
  }

  return (
    <div
      className='slide-comp-wrapper'
      onClick={() => {
        if (explanationClick && isEmbeded) {
          explanationValidation()
        }
      }}
    >
      <div
        style={{
          width: '100%',
          height: isEmbeded ? '100%' : LayoutType === 'Spiral' ? '90%' : '80%',
          justifyContent: isEmbeded ? 'normal' : 'center',
          alignItems: isEmbeded ? 'normal' : 'center',
          display: isEmbeded ? 'unset' : 'flex',
          backgroundColor:
            isEmbeded && currentPriority === Priority ? '#ffffff' : '',
          borderRadius: '4px',
          marginTop: isEmbeded ? '0px' : '4%'
        }}
      >
        {LayoutType === 'Spiral' ? (
          <div
            style={{
              width: isEmbeded ? '100%' : 'fit-content',
              height: isEmbeded ? '100%' : 'fit-content'
            }}
          >
            <p
              className='fraction-answer-label'
              style={{
                color: AnswerColorFill,
                backgroundColor: AnswerFillColor,
                fontFamily: FontStyle,
                fontStyle: Italic === 'True' ? 'italic' : 'normal',
                fontWeight: Bold === 'True' ? 'bold' : 'normal'
              }}
            >
              {isVerifyMode
                ? Answers.split('/')[1]
                  ? Answers.split('/')[0] + '/' + sliceCount.toString()
                  : Answers
                : Answers.split('/')[1]
                ? (selectedFraction + 1).toString() +
                  '/' +
                  sliceCount.toString()
                : (selectedFraction + 1).toString()}
            </p>
            <div
              style={{
                width: isEmbeded ? '100%' : '400px',
                height: isEmbeded ? '80%' : '300px',
                zIndex: 999,
                cursor: 'pointer',
                backgroundColor: '#ffffff80',
                borderRadius: '10px'
              }}
            >
              <ResponsiveContainer>
                <PieChart style={{ width: '100%', height: '100%' }}>
                  <Pie
                    data={spiralData}
                    dataKey='values'
                    direction='rtl'
                    stroke={BorderColor}
                    color={AnswerFillColor}
                    startAngle={90}
                    endAngle={-360}
                    outerRadius='100%'
                    labelLine={false}
                    nameKey='name'
                    isAnimationActive={false}
                    onClick={(e) => {
                      let isCorrect = validateAnswer()
                      let selectedIndexValue = spiralData.findIndex(
                        (obj) => obj.name === e.name
                      )
                      if (isPractice && followTheFlow && isEmbeded) {
                        if (isCorrect) {
                        } else {
                          if (
                            completed === 0 &&
                            isActive &&
                            !explanationClick
                          ) {
                            fractionClick(selectedIndexValue)
                            setSelectedFraction(selectedIndexValue)
                          }
                        }
                      } else {
                        if (completed === 0 && isActive && !explanationClick) {
                          fractionClick(selectedIndexValue)
                          setSelectedFraction(selectedIndexValue)
                        }
                      }
                    }}
                  >
                    {spiralData.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={
                          isVerifyMode
                            ? index < answerSlice
                              ? '#3EC986'
                              : AnswerFillColor
                            : isPractice
                            ? isCorrect && index <= selectedFraction
                              ? '#3EC986'
                              : index <= selectedFraction
                              ? '#FF551F'
                              : AnswerFillColor
                            : completed === 0 && isActive
                            ? index <= selectedFraction
                              ? SelectionColor
                              : AnswerFillColor
                            : isCorrect && index <= selectedFraction
                            ? '#3EC986'
                            : index <= selectedFraction
                            ? '#FF551F'
                            : AnswerFillColor
                        }
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
        ) : (
          <div
            style={{
              width: isEmbeded ? '100%' : 'fit-content',
              height: isEmbeded ? '100%' : 'fit-content'
            }}
          >
            <p
              className='fraction-answer-label'
              style={{
                color: AnswerColorFill,
                backgroundColor: AnswerFillColor,
                fontFamily: FontStyle,
                fontStyle: Italic === 'True' ? 'italic' : 'normal',
                fontWeight: Bold === 'True' ? 'bold' : 'normal'
              }}
            >
              {isVerifyMode
                ? Answers.split('/')[1]
                  ? Answers.split('/')[0] + '/' + sliceCount.toString()
                  : Answers
                : Answers.split('/')[1]
                ? (selectedFraction + 1).toString() +
                  '/' +
                  sliceCount.toString()
                : (selectedFraction + 1).toString()}
            </p>

            <div
              className='row fraction-bar-cont'
              style={{
                width:
                  !isEmbeded && LayoutType === 'Vertical' ? '400px' : '100%',
                justifyContent:
                  !isEmbeded && LayoutType === 'Horizontal'
                    ? 'center'
                    : 'space-evenly'
              }}
            >
              {Array(sliceCount)
                .fill(0)
                .map((_, index) => {
                  return (
                    <div
                      className={
                        LayoutType === 'Horizontal'
                          ? 'fraction-bar'
                          : 'col-md-12 fraction-bar'
                      }
                      style={{
                        width: isEmbeded
                          ? LayoutType === 'Horizontal'
                            ? ((100 - sliceCount) / sliceCount)
                                .toString()
                                .concat('%')
                            : undefined
                          : LayoutType === 'Horizontal'
                          ? '50px'
                          : '100%',
                        height: isEmbeded
                          ? undefined
                          : LayoutType === 'Vertical'
                          ? '50px'
                          : '400px',
                        backgroundColor: isVerifyMode
                          ? index < answerSlice
                            ? '#3EC986'
                            : AnswerFillColor
                          : isPractice
                          ? isCorrect && index <= selectedFraction
                            ? '#3EC986'
                            : index <= selectedFraction
                            ? '#FF551F'
                            : AnswerFillColor
                          : completed === 0 && isActive
                          ? index <= selectedFraction
                            ? SelectionColor
                            : AnswerFillColor
                          : isCorrect && index <= selectedFraction
                          ? '#3EC986'
                          : index <= selectedFraction
                          ? '#FF551F'
                          : AnswerFillColor
                      }}
                      onClick={() => {
                        let isCorrect = validateAnswer()
                        if (isPractice && followTheFlow && isEmbeded) {
                          if (isCorrect) {
                          } else {
                            if (
                              completed === 0 &&
                              isActive &&
                              !explanationClick
                            ) {
                              fractionClick(index)
                              setSelectedFraction(index)
                            }
                          }
                        } else {
                          if (
                            completed === 0 &&
                            isActive &&
                            !explanationClick
                          ) {
                            fractionClick(index)
                            setSelectedFraction(index)
                          }
                        }
                      }}
                    />
                  )
                })}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default FractionComponent
